import { render, staticRenderFns } from "./AXprogramanuevo.vue?vue&type=template&id=cdaeaee4"
import script from "./AXprogramanuevo.vue?vue&type=script&lang=js"
export * from "./AXprogramanuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports